<template>
  <div>
    <section-title class="mt-3" content="Datos del Evaluador" has-line />

    <div class="row my-3">
      <info-field
        class="col-3"
        label=" Nombre del Evaluador(a):"
        :value="model.evaluator?.name"
      />
      <info-field
        class="col-3"
        label="Proveedor:"
        :value="model.evaluator?.provider"
      />
      <info-field class="col-3" label="Profesión:" :value="'Especialista'" />
      <info-field
        class="col-3"
        label="#Lic.:"
        :value="model.evaluator?.license"
      />
    </div>
    <div class="row my-3">
      <info-field
        class="col-3"
        label="Ente Evaluador:"
        :value="'Corporación/Organización'"
      />
      <div class="col-3 d-flex flex-column">
        <label class="text-muted">Certificaciones</label>

        <div class="d-flex align-items-center flex-wrap">
          <label class="certification-check mr-3 mb-0">
            <input
              v-model="model.evaluator.certification.isCVE"
              disabled
              type="checkbox"
            />
            <span>CVE</span>
          </label>

          <label class="certification-check mr-3 mb-0">
            <input
              v-model="model.evaluator.certification.isICVE"
              disabled
              type="checkbox"
            />
            <span>ICVE</span>
          </label>

          <label class="certification-check mb-0">
            <input
              v-model="model.evaluator.certification.isCEV"
              disabled
              type="checkbox"
            />
            <span>CEV</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/shared/components/SectionTitle.vue';
import InfoField from './InfoField.vue';

export default {
  name: 'EvaluatorSection',
  components: {
    SectionTitle,
    InfoField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
<style scoped>
.certification-check {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #2f4f4f;
  cursor: default;
}

.certification-check input[type='checkbox'] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #cfd8dc;
  border-radius: 3px;
  position: relative;
  cursor: default;
}

.certification-check input[type='checkbox']:disabled {
  background-color: #e2e2e2;
  border-color: #e2e2e2;
}

.certification-check input[type='checkbox']:checked:disabled {
  background-color: #3f5b60;
  border-color: #3f5b60;
}

.certification-check input[type='checkbox']:checked::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
</style>
